import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Who_we_are.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import Send_message from "../../common-components/common-btn/send_message/Send_message";
import Play_animation from "../../common-components/common-animation/play-animation/Play_animation";
import { useNavigate } from "react-router-dom";

const Who_we_are = () => {
  const navigate = useNavigate();

  return (
    <section className="who-we-section">
      <Container>
        <div className="main-div">
          <Row className="justify-content-center">
            <Col lg={6} md={8} sm={12}>
              <div className="left-side">
                <div className="section-title">
                  <Heading_title title={"Who We Are"} />
                </div>
                <div className="section-text">
                  <p>
                    At Ashwa Sports and Fitness Academy, we are dedicated to
                    building a healthier, stronger, and more confident community
                    through sports and fitness.
                  </p>

                  <p>
                    Our mission is to inspire kids, youth, and adults to stay
                    active, develop discipline, and enjoy the power of movement.
                  </p>

                  <p>
                    We provide professional training in kids’ fitness,
                    athletics, running, functional training, and overall
                    physical development.
                  </p>

                  <p>
                    Our programs focus not only on improving physical strength,
                    speed, and endurance but also on building confidence,
                    teamwork, and a positive mindset. With experienced coaches
                    and structured training programs, we create a safe and
                    motivating environment where every individual can grow,
                    learn, and achieve their fitness goals. Whether you are a
                    beginner starting your fitness journey or an athlete aiming
                    to improve performance, our academy is here to support and
                    guide you every step of the way.
                  </p>

                  <p>
                    With experienced coaches and structured training programs,
                    we create a safe and motivating environment where every
                    individual can grow, learn, and achieve their fitness goals.
                    Whether you are a beginner starting your fitness journey or
                    an athlete aiming to improve performance, our academy is
                    here to support and guide you every step of the way.
                  </p>
                </div>
                <div className="button">
                  <Send_message
                    text="Discover More"
                    onClick={() => {
                      navigate("/about-us");
                    }}
                  />
                </div>
              </div>
            </Col>

            <Col lg={6} md={8} sm={12}>
              <div className="img-div">
                <div className="big-img-div">
                  <img
                    src="./assets/images/home/who_we_are/big-img.png"
                    alt="player"
                    className="big_img"
                  />
                </div>
                <div className="small-img-div">
                  <div className="inner_img_holder">
                    <img
                      src="./assets/images/home/who_we_are/small-img.png"
                      alt="yoga"
                      className="small_img"
                    />

                    <div className="lottie_holder">
                      <Play_animation />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Who_we_are;
